import { Button } from 'primereact/button'
import { useEffect, useRef, useState, useCallback } from 'react'
import html2canvas from 'html2canvas'
import { Tooltip } from 'primereact/tooltip'
import { useLocation } from 'react-router-dom'
import { baseUrl } from '../../services/PostAPI'
import MzDialog from '../../common/MzDialog'
import { Toast } from 'primereact/toast'
import AddEditSevenEnquiryScreen from '../../containers/sevenEnquiryScreen/addEditSevenEnquiryScreen/index'
import { USER_ROLE } from '../../constant/actionTypes/role'
const DEFAULT_CENTER = { lat: 18.590727879655105, lng: 73.74850060623852 }

const GmapComponent = (props) => {
  const {
    plotCoordinates,
    pinCoordinates,
    plotNumber,
    planId,
    boundaryCoordinates,
    villageName,
    stateName,
    districtName,
    adjacentPlots,
    plotArea,
    setLoading,
    plotId,
    userRole
  } = props.gMapProps
  const [visible, setVisible] = useState(false)
  const [, setMeasuring] = useState(false)
  const [totalDistance, setTotalDistance] = useState(0)
  const [visibleinfo, setVisibleinfo] = useState(false)
  const [showMeasuring, setShowMeasuring] = useState(true)
  const [isDownload, setDownload] = useState(false)
  const [isDistanceVisible, setIsDistanceVisible] = useState(false)
  const [visibleSevenEnquiry, setVisibleSevenEnquiry] = useState(false)
  const [showPreview, setShowPreview] = useState(false)
  const toastRef = useRef(null)
  const mapContainerRef = useRef(null)
  const mapRef = useRef(null)
  const directionsRendererRef = useRef(null)
  const directionsServiceRef = useRef(null)
  const polylineRef = useRef(null)
  const infoWindowRef = useRef(null)
  const previewMapRef = useRef(null);
  const previewMapInstanceRef = useRef(null);
  const location = useLocation()
  const isDashboardLocation = location.pathname === '/dashbaord/location'
  useEffect(() => {
    if (plotCoordinates?.length > 0) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }, [plotCoordinates])

  useEffect(() => {
    if (mapRef.current && adjacentPlots?.length > 0) {
      setTimeout(() => {
        updateMapViewForAllPlots()
      }, 1500)
    }
  }, [adjacentPlots])

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
          resolve()
          return
        }
        const script = document.createElement('script')
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDDSTNCtV1XVngi_7dyaKxFeOL-paKpWr0&libraries=drawing,geometry&callback=initMap`
        script.async = true
        script.defer = true
        script.onload = resolve
        script.onerror = reject
        document.body.appendChild(script)
      })
    }

    const initializeMap = () => {
      const mapCenter = pinCoordinates?.[0] || DEFAULT_CENTER
      mapRef.current = new window.google.maps.Map(mapContainerRef.current, {
        zoom: pinCoordinates ? 18.5 : 13,
        center: mapCenter,
        scaleControl: true,
        // mapTypeId: window.google.maps.MapTypeId.SATELLITE,
        mapTypeId: window.google.maps.MapTypeId.HYBRID,
        mapTypeControl: true
      })

      directionsServiceRef.current = new window.google.maps.DirectionsService()
      directionsRendererRef.current =
        new window.google.maps.DirectionsRenderer()
      directionsRendererRef.current.setMap(mapRef.current)

      if (plotCoordinates && Array.isArray(plotCoordinates)) {
        plotCoordinates.forEach((coords) => {
          new window.google.maps.Polygon({
            paths: coords,
            strokeColor: '#0bb980',
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: '#0bb980',
            fillOpacity: 0.3
          }).setMap(mapRef.current)
        })

        const flattenedCoordinates = plotCoordinates.flat()
        calculatePolygonDistances(flattenedCoordinates)
        displayDistancesOnMap(flattenedCoordinates, mapRef.current, { 
          maxThresholdDeg: 160, 
          useDirectionalLogic: true 
        });

      }

      if (boundaryCoordinates && Array.isArray(boundaryCoordinates)) {
        boundaryCoordinates.forEach((point) => {
          const [lat, lng] = point.coordinates; 

          new window.google.maps.Marker({
            position: { lat, lng },
            map: mapRef.current,
            label: {
              text: point.serialNumber,
              color: "white",
              fontSize: "8px",
              fontWeight: "bold"
            },

            icon: {
              path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z",
              fillColor: "#A2C523",
              fillOpacity: 0.9,
              strokeWeight: 1,
              strokeColor: "#ffffff",
              scale: 1,
              anchor: new window.google.maps.Point(12, 24),
              labelOrigin: new window.google.maps.Point(12, 9)
            }
          });
        });
      }

      if (Array.isArray(adjacentPlots)) {
      adjacentPlots.forEach(({ plotNumber, plotCordinates, pinCordinates }) => {
        if (plotCordinates) {
          const path = plotCordinates[0]
          const polygon = new window.google.maps.Polygon({
            paths: path,
            strokeColor: '#c511ceff',
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: '#f475ceff',
            fillOpacity: 0.3
          })

          polygon.setMap(mapRef.current)
        }
        if (Array.isArray(pinCordinates) && pinCordinates.length > 0) {
          pinCordinates.forEach((pinCoord) => {
            new window.google.maps.Marker({
              position: pinCoord,
              map: mapRef.current,
              title: plotNumber || '',
              icon: {
                path: window.google.maps.SymbolPath.CIRCLE,
                scale: 12,
                fillColor: 'green',
                fillOpacity: 0.5,
                strokeWeight: 2,
                strokeColor: 'white'
              },
              label: {
                text: plotNumber || '',
                color: 'white',
                fontSize: '10px',
                zIndex: 9999,
                fontWeight: 'bold'
              }
            })
          })
        }
      })
      }


      if (pinCoordinates) {
        pinCoordinates.forEach((pinCoord) => {
          new window.google.maps.Marker({
            position: pinCoord,
            map: mapRef.current,
            title: plotNumber || '',
            label: {
              text: plotNumber || '',
              color: 'white',
              fontSize: '11px',
              fontWeight: 'bold'
            },
            icon: {
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 15,
              fillColor: 'green',
              fillOpacity: 0.5,
              strokeWeight: 2,
              strokeColor: 'white'
            }
          })
        })
      }
    }

    window.initMap = initializeMap
    loadGoogleMapsScript().then(() => {
      if (document.readyState === 'complete') {
        initializeMap()
      }
    })

    function toRadians(deg) {
      return (deg * Math.PI) / 180;
    }

    function haversineDistance(p1, p2) {
      const R = 6371e3;
      const lat1 = toRadians(p1.lat);
      const lon1 = toRadians(p1.lng);
      const lat2 = toRadians(p2.lat);
      const lon2 = toRadians(p2.lng);

      const dLat = lat2 - lat1;
      const dLon = lon2 - lon1;

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    function calculateTurnAngle(prev, curr, next) {
      const v1x = curr.lng - prev.lng;
      const v1y = curr.lat - prev.lat;
      const v2x = next.lng - curr.lng;
      const v2y = next.lat - curr.lat;

      const mag1 = Math.hypot(v1x, v1y);
      const mag2 = Math.hypot(v2x, v2y);

      if (mag1 < 1e-9 || mag2 < 1e-9) return 0;

      let cos = (v1x * v2x + v1y * v2y) / (mag1 * mag2);
      cos = Math.min(1, Math.max(-1, cos));
      const angleRad = Math.acos(cos);
      const angleDeg = (angleRad * 180) / Math.PI;
      return angleDeg;
    }

    function calculateDirectionalTurnAngle(prev, curr, next) {
      const v1x = curr.lng - prev.lng;
      const v1y = curr.lat - prev.lat;
      const v2x = next.lng - curr.lng;
      const v2y = next.lat - curr.lat;

      const mag1 = Math.hypot(v1x, v1y);
      const mag2 = Math.hypot(v2x, v2y);

      if (mag1 < 1e-9 || mag2 < 1e-9) return { angle: 0, direction: 'straight' };
      let cos = (v1x * v2x + v1y * v2y) / (mag1 * mag2);
      cos = Math.min(1, Math.max(-1, cos));
      const angleRad = Math.acos(cos);
      const angleDeg = (angleRad * 180) / Math.PI;
      const crossProduct = v1x * v2y - v1y * v2x;
      
      let direction = 'straight';
      if (Math.abs(crossProduct) > 1e-9) {
        direction = crossProduct > 0 ? 'left' : 'right';
      }
      const bearing1 = Math.atan2(v1y, v1x) * (180 / Math.PI);
      const bearing2 = Math.atan2(v2y, v2x) * (180 / Math.PI);
      let bearingChange = bearing2 - bearing1;
      
      if (bearingChange > 180) bearingChange -= 360;
      if (bearingChange < -180) bearingChange += 360;

      const result = { 
        angle: angleDeg, 
        direction: direction,
        bearingChange: Math.abs(bearingChange),
        isSignificantTurn: angleDeg > 20 && Math.abs(bearingChange) > 15
      };
      return result;
    }

    function computePathDistanceAlong(points, startIdx, endIdx) {
      let dist = 0;
      for (let i = startIdx; i < endIdx; i++) {
        dist += haversineDistance(points[i], points[i + 1]);
      }
      return dist;
    }

    function computeMidpointAlongPath(points, startIdx, endIdx) {
      const total = computePathDistanceAlong(points, startIdx, endIdx);
      if (total === 0) {
        const p1 = points[startIdx];
        const p2 = points[endIdx];
        return { lat: (p1.lat + p2.lat) / 2, lng: (p1.lng + p2.lng) / 2 };
      }
      const half = total / 2;
      let accum = 0;

      for (let i = startIdx; i < endIdx; i++) {
        const a = points[i];
        const b = points[i + 1];
        const seg = haversineDistance(a, b);
        if (accum + seg >= half) {
          const remaining = half - accum;
          const t = seg === 0 ? 0 : remaining / seg;
          return {
            lat: a.lat + (b.lat - a.lat) * t,
            lng: a.lng + (b.lng - a.lng) * t
          };
        }
        accum += seg;
      }

      const p1 = points[startIdx];
      const p2 = points[endIdx];
      return { lat: (p1.lat + p2.lat) / 2, lng: (p1.lng + p2.lng) / 2 };
    }

    function createLabelMarker(map, position, text) {
      return new window.google.maps.Marker({
        position,
        map,
        label: {
          text: `${text}`,
          color: 'white',
          fontSize: '10px',
          fontWeight: 'bold'
        },
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 0
        }
      });
    }

    function createRedPoint(map, position) {
      return new window.google.maps.Marker({
        position,
        map,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 4,
          fillColor: 'red',
          fillOpacity: 1,
          strokeWeight: 2,
          strokeColor: 'white'
        }
      });
    }

    function displayDistancesOnMap(plotCoordinates, mapInstance, options) {
      if (Array.isArray(plotCoordinates[0])) {
        plotCoordinates = plotCoordinates[0];
      }
      if (!plotCoordinates || plotCoordinates.length < 2) return;
      const minThreshold = (options && options.minThresholdDeg) || 10;
      const maxThreshold = (options && options.maxThresholdDeg) || 160;
      const useDirectionalLogic = (options && options.useDirectionalLogic) !== false;
      const turnIndices = [];

      for (let i = 1; i < plotCoordinates.length - 1; i++) {
        const prev = plotCoordinates[i - 1];
        const cur = plotCoordinates[i];
        const next = plotCoordinates[i + 1];

        if (useDirectionalLogic) {
          const turnData = calculateDirectionalTurnAngle(prev, cur, next);
          if (turnData.angle >= minThreshold && 
              turnData.angle <= maxThreshold && 
              turnData.isSignificantTurn) {
            turnIndices.push(i);
          } 
        } else {
          const angle = calculateTurnAngle(prev, cur, next);
          if (angle >= minThreshold && angle <= maxThreshold) {
            turnIndices.push(i);
          }
        }
      }

      const lastIndex = plotCoordinates.length - 1;
      const keyIndices = [0, ...turnIndices.filter(i => i > 0 && i < lastIndex), lastIndex];

      keyIndices.forEach((idx) => {
        const point = plotCoordinates[idx];
        createRedPoint(mapInstance, point);
      });

      for (let k = 0; k < keyIndices.length - 1; k++) {
        const startIdx = keyIndices[k];
        const endIdx = keyIndices[k + 1];
        const distanceMeters = computePathDistanceAlong(plotCoordinates, startIdx, endIdx);
        const midpoint = computeMidpointAlongPath(plotCoordinates, startIdx, endIdx);
        createLabelMarker(mapInstance, midpoint, `${distanceMeters.toFixed(2)} m.`);
      }
    }

    return () => {
      window.initMap = undefined
      if (mapRef.current) mapRef.current = null
      if (directionsRendererRef.current)
        directionsRendererRef.current.setMap(null)
      if (directionsServiceRef.current) directionsServiceRef.current = null
      if (polylineRef.current) polylineRef.current.setMap(null)
      if (infoWindowRef.current) infoWindowRef.current.close()
    }
  }, [pinCoordinates, plotCoordinates, plotNumber, adjacentPlots,boundaryCoordinates])



  useEffect(() => {
    if (showPreview && previewMapRef.current) {
      const loadGoogleMapsScript = () => {
        return new Promise((resolve, reject) => {
          if (window.google && window.google.maps) {
            resolve()
            return
          }
          const script = document.createElement('script')
          script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDDSTNCtV1XVngi_7dyaKxFeOL-paKpWr0&libraries=drawing,geometry&callback=initMap`
          script.async = true
          script.defer = true
          script.onload = resolve
          script.onerror = reject
          document.body.appendChild(script)
        })
      }

      const initializeMap = () => {
        const mapCenter = pinCoordinates?.[0] || DEFAULT_CENTER
        previewMapInstanceRef.current = new window.google.maps.Map(previewMapRef.current, {
          zoom: pinCoordinates ? 18.5 : 13,
          center: mapCenter,
          mapTypeId: window.google.maps.MapTypeId.SATELLITE,
          // Explicitly control each UI element
          disableDefaultUI: false,
          zoomControl: true,
          fullscreenControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          clickableIcons: false,
          keyboardShortcuts: false,
          gestureHandling: 'greedy'
        })

        directionsServiceRef.current = new window.google.maps.DirectionsService()
        directionsRendererRef.current =
          new window.google.maps.DirectionsRenderer()
        directionsRendererRef.current.setMap(previewMapInstanceRef.current)

        if (plotCoordinates && Array.isArray(plotCoordinates)) {
          plotCoordinates.forEach((coords) => {
            new window.google.maps.Polygon({
              paths: coords,
              strokeColor: '#0bb980',
              strokeOpacity: 0.9,
              strokeWeight: 2,
              fillColor: '#0bb980',
              fillOpacity: 0.3
            }).setMap(previewMapInstanceRef.current)
          })

          const flattenedCoordinates = plotCoordinates.flat()
         calculatePolygonDistances(flattenedCoordinates)
          displayDistancesOnMap(flattenedCoordinates, previewMapInstanceRef.current, { 
            maxThresholdDeg: 160, 
            useDirectionalLogic: true 
          });

        }

        if (boundaryCoordinates && Array.isArray(boundaryCoordinates)) {
          boundaryCoordinates.forEach((point) => {
            const [lat, lng] = point.coordinates;

            new window.google.maps.Marker({
              position: { lat, lng },
              map: previewMapInstanceRef.current,
              label: {
                text: point.serialNumber,
                color: "white",
                fontSize: "8px",
                fillOpacity: 0.3,
                fontWeight: "bold"
              },

              icon: {
                path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z",
                fillColor: "#A2C523",
                strokeWeight: 1,
                fillOpacity: 0.7,
                strokeColor: "#ffffff",
                scale: 1,
                anchor: new window.google.maps.Point(12, 24),
                labelOrigin: new window.google.maps.Point(12, 9)
              }
            });
          });
        }


        if (Array.isArray(adjacentPlots)) {
        adjacentPlots.forEach(({ plotNumber, plotCordinates, pinCordinates }) => {
          if (plotCordinates) {
            const path = plotCordinates[0]
            const polygon = new window.google.maps.Polygon({
              paths: path,
              strokeColor: '#c511ceff',
              strokeOpacity: 0.9,
              strokeWeight: 2,
              fillColor: '#f475ceff',
              fillOpacity: 0.3
            })

            polygon.setMap(previewMapInstanceRef.current)
          }
          if (Array.isArray(pinCordinates) && pinCordinates.length > 0) {
            pinCordinates.forEach((pinCoord) => {
              new window.google.maps.Marker({
                position: pinCoord,
                map: previewMapInstanceRef.current,
                title: plotNumber || '',
                icon: {
                  path: window.google.maps.SymbolPath.CIRCLE,
                  scale: 12,
                  fillColor: 'green',
                  fillOpacity: 0.5,
                  strokeWeight: 2,
                  strokeColor: 'white'
                },
                label: {
                  text: plotNumber || '',
                  color: 'white',
                  fontSize: '10px',
                  zIndex: 9999,
                  fontWeight: 'bold'
                }
              })
            })
          }
        })
        }


        if (pinCoordinates) {
          pinCoordinates.forEach((pinCoord) => {
            new window.google.maps.Marker({
              position: pinCoord,
              map: previewMapInstanceRef.current,
              title: plotNumber || '',
              label: {
                text: plotNumber || '',
                color: 'white',
                fontSize: '11px',
                fontWeight: 'bold'
              },
              icon: {
                path: window.google.maps.SymbolPath.CIRCLE,
                scale: 15,
                fillColor: 'green',
                fillOpacity: 0.5,
                strokeWeight: 2,
                strokeColor: 'white'
              }
            })
          })
        }
      }

      window.initMap = initializeMap
      loadGoogleMapsScript().then(() => {
        if (document.readyState === 'complete') {
          initializeMap()
        }
      })

      function toRadians(deg) {
        return (deg * Math.PI) / 180;
      }

      function haversineDistance(p1, p2) {
        const R = 6371e3;
        const lat1 = toRadians(p1.lat);
        const lon1 = toRadians(p1.lng);
        const lat2 = toRadians(p2.lat);
        const lon2 = toRadians(p2.lng);

        const dLat = lat2 - lat1;
        const dLon = lon2 - lon1;

        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
      }

      function calculateTurnAngle(prev, curr, next) {
        const v1x = curr.lng - prev.lng;
        const v1y = curr.lat - prev.lat;
        const v2x = next.lng - curr.lng;
        const v2y = next.lat - curr.lat;

        const mag1 = Math.hypot(v1x, v1y);
        const mag2 = Math.hypot(v2x, v2y);

        if (mag1 < 1e-9 || mag2 < 1e-9) return 0;

        let cos = (v1x * v2x + v1y * v2y) / (mag1 * mag2);
        cos = Math.min(1, Math.max(-1, cos));
        const angleRad = Math.acos(cos);
        const angleDeg = (angleRad * 180) / Math.PI;
        return angleDeg;
      }

      function computePathDistanceAlong(points, startIdx, endIdx) {
        let dist = 0;
        for (let i = startIdx; i < endIdx; i++) {
          dist += haversineDistance(points[i], points[i + 1]);
        }
        return dist;
      }

      function computeMidpointAlongPath(points, startIdx, endIdx) {
        const total = computePathDistanceAlong(points, startIdx, endIdx);
        if (total === 0) {
          const p1 = points[startIdx];
          const p2 = points[endIdx];
          return { lat: (p1.lat + p2.lat) / 2, lng: (p1.lng + p2.lng) / 2 };
        }
        const half = total / 2;
        let accum = 0;

        for (let i = startIdx; i < endIdx; i++) {
          const a = points[i];
          const b = points[i + 1];
          const seg = haversineDistance(a, b);
          if (accum + seg >= half) {
            const remaining = half - accum;
            const t = seg === 0 ? 0 : remaining / seg;
            return {
              lat: a.lat + (b.lat - a.lat) * t,
              lng: a.lng + (b.lng - a.lng) * t
            };
          }
          accum += seg;
        }

        const p1 = points[startIdx];
        const p2 = points[endIdx];
        return { lat: (p1.lat + p2.lat) / 2, lng: (p1.lng + p2.lng) / 2 };
      }

      function createLabelMarker(map, position, text) {
        return new window.google.maps.Marker({
          position,
          map,
          label: {
            text: `${text}`,
            color: 'white',
            fontSize: '10px',
            fontWeight: 'bold'
          },
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 0
          }
        });
      }

      function createRedPoint(map, position) {
        return new window.google.maps.Marker({
          position,
          map,
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale:4,
            fillColor: 'red',
            fillOpacity: 1,
            strokeWeight: 2,
            strokeColor: 'white'
          }
        });
      }

      function calculateDirectionalTurnAngle(prev, curr, next) {
        const v1x = curr.lng - prev.lng;
        const v1y = curr.lat - prev.lat;
        const v2x = next.lng - curr.lng;
        const v2y = next.lat - curr.lat;

        const mag1 = Math.hypot(v1x, v1y);
        const mag2 = Math.hypot(v2x, v2y);

        if (mag1 < 1e-9 || mag2 < 1e-9) return { angle: 0, direction: 'straight' };

        let cos = (v1x * v2x + v1y * v2y) / (mag1 * mag2);
        cos = Math.min(1, Math.max(-1, cos));
        const angleRad = Math.acos(cos);
        const angleDeg = (angleRad * 180) / Math.PI;

        const crossProduct = v1x * v2y - v1y * v2x;
        
        let direction = 'straight';
        if (Math.abs(crossProduct) > 1e-9) {
          direction = crossProduct > 0 ? 'left' : 'right';
        }
        const bearing1 = Math.atan2(v1y, v1x) * (180 / Math.PI);
        const bearing2 = Math.atan2(v2y, v2x) * (180 / Math.PI);
        let bearingChange = bearing2 - bearing1;
        if (bearingChange > 180) bearingChange -= 360;
        if (bearingChange < -180) bearingChange += 360;

        const result = { 
          angle: angleDeg, 
          direction: direction,
          bearingChange: Math.abs(bearingChange),
          isSignificantTurn: angleDeg > 20 && Math.abs(bearingChange) > 15
        };
         return result;
      }

      function displayDistancesOnMap(plotCoordinates, mapInstance, options) {
        if (Array.isArray(plotCoordinates[0])) {
          plotCoordinates = plotCoordinates[0];
        }
        if (!plotCoordinates || plotCoordinates.length < 2) return;
        const minThreshold = (options && options.minThresholdDeg) || 10;
        const maxThreshold = (options && options.maxThresholdDeg) || 160;
        const useDirectionalLogic = (options && options.useDirectionalLogic) !== false;
        const turnIndices = [];

        for (let i = 1; i < plotCoordinates.length - 1; i++) {
          const prev = plotCoordinates[i - 1];
          const cur = plotCoordinates[i];
          const next = plotCoordinates[i + 1];

          if (useDirectionalLogic) {
            const turnData = calculateDirectionalTurnAngle(prev, cur, next);
            if (turnData.angle >= minThreshold && 
                turnData.angle <= maxThreshold && 
                turnData.isSignificantTurn) {
              turnIndices.push(i);
            } 
          } else {
            const angle = calculateTurnAngle(prev, cur, next);
            if (angle >= minThreshold && angle <= maxThreshold) {
              turnIndices.push(i);
            }
          }
        }

        const lastIndex = plotCoordinates.length - 1;
        const keyIndices = [0, ...turnIndices.filter(i => i > 0 && i < lastIndex), lastIndex];

        keyIndices.forEach((idx) => {
          const point = plotCoordinates[idx];
          createRedPoint(mapInstance, point);
        });

        for (let k = 0; k < keyIndices.length - 1; k++) {
          const startIdx = keyIndices[k];
          const endIdx = keyIndices[k + 1];
          const distanceMeters = computePathDistanceAlong(plotCoordinates, startIdx, endIdx);
          const midpoint = computeMidpointAlongPath(plotCoordinates, startIdx, endIdx);
          createLabelMarker(mapInstance, midpoint, `${distanceMeters.toFixed(2)} m.`);
        }
      }

      return () => {
        window.initMap = undefined
        if (previewMapInstanceRef.current) previewMapInstanceRef.current = null
        if (directionsRendererRef.current)
          directionsRendererRef.current.setMap(null)
        if (directionsServiceRef.current) directionsServiceRef.current = null
        if (polylineRef.current) polylineRef.current.setMap(null)
        if (infoWindowRef.current) infoWindowRef.current.close()
      }
    }
  }, [pinCoordinates, showPreview, plotCoordinates, plotNumber, adjacentPlots,boundaryCoordinates])

  const createPencilCursor = () => {
    const canvas = document.createElement('canvas')
    canvas.width = 32
    canvas.height = 32
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = 'white'
    ctx.font = '25px "Pencil Icon"'
    ctx.textBaseline = 'middle'

    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate(Math.PI / -1.4)
    ctx.fillText('\u270F', -12, 0)
    return canvas.toDataURL('image/png')
  }

  const [dragging, setDragging] = useState(false)
  const [draggingIndex, setDraggingIndex] = useState(null)

  const startMeasuring = () => {
    if (mapRef.current) {
      setMeasuring(true)
      setTotalDistance(0)
      polylineRef.current = new window.google.maps.Polyline({
        map: mapRef.current,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 3,
        editable: true
      })

      mapRef.current.setOptions({
        draggableCursor: `url(${createPencilCursor()}), auto`
      })

      mapRef.current.addListener('click', addPoint)

      mapRef.current.addListener('mousemove', (event) => {
        if (dragging && draggingIndex !== null) {
          const path = polylineRef.current.getPath()
          path.setAt(draggingIndex, event.latLng)
          updateDistance(path)
        }
      })

      mapRef.current.addListener('mousedown', (event) => {
        if (polylineRef.current) {
          const path = polylineRef.current.getPath()
          const latLng = event.latLng

          let closestPointIndex = -1
          let minDistance = Infinity

          path.forEach((point, index) => {
            const distance =
              window.google.maps.geometry.spherical.computeDistanceBetween(
                point,
                latLng
              )
            if (distance < minDistance) {
              minDistance = distance
              closestPointIndex = index
            }
          })

          if (
            closestPointIndex === 0 ||
            closestPointIndex === path.getLength() - 1
          ) {
            if (minDistance < 10) {
              setDragging(true)
              setDraggingIndex(closestPointIndex)
            }
          }
        }
      })

      mapRef.current.addListener('mouseup', () => {
        setDragging(false)
        setDraggingIndex(null)
      })

      polylineRef.current.getPath().addListener('set_at', () => {
        updateDistance(polylineRef.current.getPath())
      })

      polylineRef.current.getPath().addListener('insert_at', () => {
        updateDistance(polylineRef.current.getPath())
      })

      polylineRef.current.getPath().addListener('remove_at', () => {
        updateDistance(polylineRef.current.getPath())
      })
    }
  }

  const handleToggle = () => {
    setVisibleinfo(!visibleinfo)
  }
  const handleToggleinfo = () => {
    setShowMeasuring(!showMeasuring)
  }
  const handleClose = () => {
    setVisibleinfo(false)
  }

  const addPoint = (event) => {
    if (!polylineRef.current || dragging) return

    const path = polylineRef.current.getPath()
    if (!path) return

    if (
      path.getLength() > 0 &&
      path.getAt(path.getLength() - 1).equals(event.latLng)
    ) {
      return
    }

    path.push(event.latLng)

    updateDistance(path)

    setIsDistanceVisible(true)
  }

  const updateDistance = useCallback((path) => {
    let totalDistance = 0

    for (let i = 1; i < path.getLength(); i++) {
      const startPoint = path.getAt(i - 1)
      const endPoint = path.getAt(i)
      const segmentDistance =
        window.google.maps.geometry.spherical.computeDistanceBetween(
          startPoint,
          endPoint
        )
      totalDistance += segmentDistance
    }

    setTotalDistance(totalDistance)

    setIsDistanceVisible(totalDistance > 0)
  }, [])

  const undoLastPoint = useCallback(() => {
    if (!polylineRef.current) return

    const path = polylineRef.current.getPath()
    if (path.getLength() > 0) {
      path.pop()
      updateDistance(path)
    }

    if (path.getLength() === 0) {
      setIsDistanceVisible(false)
    }
  }, [updateDistance, setIsDistanceVisible])

  useEffect(() => {
    const handleUndoShortcut = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
        event.preventDefault()
        undoLastPoint()
      }
    }
    window.addEventListener('keydown', handleUndoShortcut)
    return () => {
      window.removeEventListener('keydown', handleUndoShortcut)
    }
  }, [undoLastPoint])

  const clearMeasurement = () => {
    if (polylineRef.current) {
      polylineRef.current.setMap(null)
      polylineRef.current = null
    }

    if (infoWindowRef.current) {
      infoWindowRef.current.close()
      infoWindowRef.current = null
    }
    setMeasuring(false)
    setTotalDistance(0)
    if (mapRef.current) {
      mapRef.current.setOptions({
        draggableCursor: null
      })
    }
    setIsDistanceVisible(false)
  }

  const handleGetDirections = () => {
    if (!navigator.geolocation) {
      console.error('Geolocation is not supported by this browser.')
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }

        if (!pinCoordinates || pinCoordinates.length === 0) {
          console.error('Pin coordinates are not available.')
          return
        }

        const destination = pinCoordinates[0]
        const directionsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLocation.lat},${userLocation.lng}&destination=${destination.lat},${destination.lng}&travelmode=driving`

        const userAgent = navigator.userAgent
        const isMobile = /Mobi|Android/i.test(userAgent)
        const isiOS = /iPhone|iPad|iPod/i.test(userAgent)

        if (isMobile) {
          const mobileUrl = `geo:${userLocation.lat},${userLocation.lng}?q=${destination.lat},${destination.lng}`
          window.location.href = mobileUrl
        } else if (isiOS) {
          const appleMapsUrl = `https://maps.apple.com/?saddr=${userLocation.lat},${userLocation.lng}&daddr=${destination.lat},${destination.lng}&dirflg=d`
          window.location.href = appleMapsUrl
        } else {
          window.open(directionsUrl, '_blank')
        }
      },
      (error) => {
        console.error("Error getting user's location:", error)
        setLoading(true)
      }
    )
  }

  const downloadPlotPDF = async (plotId, screenshotBlob) => {
    try {
      
      const base64String = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result;
          const base64Data = result.split(',')[1];
          resolve(base64Data);
        };
        reader.onerror = reject;
        reader.readAsDataURL(screenshotBlob);
      });

      const formData = new FormData();
      const base64Blob = new Blob([base64String], { type: 'text/plain' });
      formData.append('screenshot', base64Blob, 'map-screenshot-base64.txt');

      const token = localStorage.getItem('token');
      if (!token) throw new Error('Authorization token not found');

      const shouldUsePlanId = userRole === USER_ROLE.SUPER_ADMIN && planId;
      const apiUrl = shouldUsePlanId
        ? `${baseUrl}/plot/${plotId}/pdf?planId=${planId}`
        : `${baseUrl}/plot/${plotId}/pdf`;


      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to download PDF: ${response.statusText}`);
      }
      let fileName = `plot-${plotId}.pdf`;
      const disposition = response.headers.get("content-disposition");
      if (disposition && disposition.includes("filename=")) {
        fileName = disposition
          .split("filename=")[1]
          .replace(/["']/g, "") 
          .trim();
      }
      const pdfBlob = await response.blob();
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `plot-${plotId}.pdf`;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error('downloadPlotPDF error:', error);
      return false;
    }
  };


  const TARGET_W = 894
  const TARGET_H = 736

  const handleDownload = async () => {
    setShowPreview(true)
  }

  const handleConfirmDownload = async () => {
    setDownload(true);
    try {
      if (!previewMapRef.current) {
        throw new Error('Preview map DOM element is not available');
      }
      if (!document.contains(previewMapRef.current)) {
        throw new Error('Preview map element is not attached to the document');
      }
      const style = document.createElement('style');
      style.innerHTML =
        '.gmnoprint{display:none!important}.gm-control-active{display:none!important}.gm-style-cc{display:none!important}';
      document.head.appendChild(style);
      await new Promise(resolve => setTimeout(resolve, 500));
      const srcCanvas = await html2canvas(previewMapRef.current, {
        useCORS: true,
        scale: 2,
        logging: false,
        allowTaint: true,
        backgroundColor: null,
      });
      document.head.removeChild(style);
      const dstCanvas = document.createElement('canvas');
      dstCanvas.width = TARGET_W;
      dstCanvas.height = TARGET_H;
      const ctx = dstCanvas.getContext('2d', { willReadFrequently: false });
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      const sW = srcCanvas.width,
        sH = srcCanvas.height;
      const srcRatio = sW / sH,
        dstRatio = TARGET_W / TARGET_H;
      if (srcRatio > dstRatio) {
        const newW = sH * dstRatio;
        const sx = (sW - newW) / 2;
        ctx.drawImage(srcCanvas, sx, 0, newW, sH, 0, 0, TARGET_W, TARGET_H);
      } else {
        const newH = sW / dstRatio;
        const sy = (sH - newH) / 2;
        ctx.drawImage(srcCanvas, 0, sy, sW, newH, 0, 0, TARGET_W, TARGET_H);
      }
      const blob = await new Promise(resolve => {
        dstCanvas.toBlob(resolve, 'image/png', 1.0);
      });
      const downloadSuccess = await downloadPlotPDF(plotId, blob);
      
      if (downloadSuccess) {
        toastRef.current?.show({
          severity: 'success',
          summary: 'PDF Downloaded successfully.',
          life: 1000,
        });
        setShowPreview(false);
      } else {
        throw new Error('PDF download failed');
      }
    } catch (error) {
      console.error('Download failed:', error);
      toastRef.current?.show({
        severity: 'error',
        summary: 'PDF download failed. Please try again.',
        life: 2000,
      });
    } finally {
      setDownload(false);
    }
  };


  const handleSevenEnquiry = () => {
    setVisibleSevenEnquiry(true)
  }
  const calculatePlotsBounds = () => {
    const bounds = new window.google.maps.LatLngBounds()
    if (plotCoordinates && Array.isArray(plotCoordinates)) {
      plotCoordinates.flat(2).forEach(coord => {
        if (coord && typeof coord.lat === 'number' && typeof coord.lng === 'number') {
          bounds.extend(coord)
        }
      })
    }
    if (adjacentPlots && Array.isArray(adjacentPlots)) {
      adjacentPlots.forEach(({ plotCordinates }) => {
        if (plotCordinates && Array.isArray(plotCordinates)) {
          plotCordinates.flat(2).forEach(coord => {
            if (coord && typeof coord.lat === 'number' && typeof coord.lng === 'number') {
              bounds.extend(coord)
            }
          })
        }
      })
    }

    return bounds
  }

  const updateMapViewForAllPlots = () => {
    if (!mapRef.current) return
    const bounds = calculatePlotsBounds()
    if (bounds && !bounds.isEmpty()) {
      const mapDiv = mapContainerRef.current
      if (mapDiv) {
        const mapWidth = mapDiv.offsetWidth
        const mapHeight = mapDiv.offsetHeight
        const ne = bounds.getNorthEast()
        const sw = bounds.getSouthWest()
        const latDiff = ne.lat() - sw.lat()
        const lngDiff = ne.lng() - sw.lng()
        const latZoom = Math.log2(360 * mapHeight / (latDiff * 256))
        const lngZoom = Math.log2(360 * mapWidth / (lngDiff * 256))
        const optimalZoom = Math.min(latZoom, lngZoom)
        const clampedZoom = Math.max(8, Math.min(20, Math.floor(optimalZoom)))
        mapRef.current.setCenter(bounds.getCenter())
        mapRef.current.setZoom(clampedZoom)
      }
    }
  }

  function calculatePolygonDistances(plotCoordinates) {
    const flattenedCoordinates = Array.isArray(plotCoordinates[0])
      ? plotCoordinates.flat()
      : plotCoordinates
    const R = 6371e3
    const toRadians = (degrees) => degrees * (Math.PI / 180)
    const distances = []
    for (let i = 0; i < flattenedCoordinates.length - 1; i++) {
      const point1 = flattenedCoordinates[i]
      const point2 = flattenedCoordinates[i + 1]
      const lat1 = toRadians(point1.lat)
      const lon1 = toRadians(point1.lng)
      const lat2 = toRadians(point2.lat)
      const lon2 = toRadians(point2.lng)
      const dLat = lat2 - lat1
      const dLon = lon2 - lon1
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1) *
        Math.cos(lat2) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      const distance = R * c
      distances.push({
        distance,
        coordinates: [point1, point2]
      })
    }
    return distances
  }

  calculatePolygonDistances(plotCoordinates)
  return (
    <div>
      <div
        className="cardinfo relative justify-content-center   w-full h-full"
        style={isDashboardLocation ? {} : { marginTop: '72px' }}
      >
        {visibleinfo && (
          <div className="cardinfo z-3 absolute right-0 mr-8 mt-8   border-round bg-white px-2 custom-margin">
            <Button
              icon="pi pi-times"
              className="p-button-text p-button-sm"
              onClick={handleClose}
              style={{
                position: 'absolute',
                top: '-3px',
                right: '-3px',
                color: 'red',
                zIndex: 10
              }}
            />
            <ul className="    p-0 ">
              <div className="text-center mb-2">
                <div className="text-900 text-sm">
                  <div className="text-900 text-xs">{plotNumber || ''}</div>
                  <div className="text-600 text-xs">{villageName || ''}</div>
                  <div className="flex justify-content-center w-full ">
                    <div className="text-900 text-xs">{districtName || ''}</div>
                    , &nbsp;
                    <div className="text-900 text-xs">{stateName || ''}</div>
                  </div>
                </div>
              </div>

              <li className="flex items-center mb-2">
                <i className="pi pi-play-circle text-green-500 mr-2"></i>
                <span className="text-600 text-xs">Area:</span>
                <span className="text-900 ml-2 text-xs">
                  {plotArea ? plotArea : 'N/A'} <sup></sup>
                </span>
              </li>
            </ul>
          </div>
        )}
        <div
          id="map"
          ref={mapContainerRef}
          style={{ height: 'calc(99vh - 4rem)', width: '100%' }}
        ></div>

        {visible && (
          <>
            <div className="grid top-0 right-0 flex-column mt-2 absolute mt-6 p-2">
              {plotCoordinates && showMeasuring && (
                <div className="col-6 md:col-3 p-1">
                  <Button
                    raised
                    severity="secondary"
                    outlined
                    icon=" pi pi-pencil text-700 text-xs"
                    className="bg-white no-outline w-xs sidebutton"
                    onClick={() => {
                      startMeasuring()
                      handleToggleinfo()
                    }}
                    data-pr-tooltip="start measurement"
                    data-pr-position="left"
                    disabled={!plotCoordinates}
                  />
                  <Tooltip target=".p-button" />
                </div>
              )}

              {plotCoordinates && !showMeasuring && (
                <div className="col-6 md:col-3 p-1">
                  <Button
                    raised
                    severity="secondary"
                    outlined
                    icon=" pi pi-eraser text-700 text-xs"
                    className="bg-white no-outline w-xs sidebutton"
                    onClick={() => {
                      clearMeasurement()
                      handleToggleinfo()
                    }}
                    data-pr-tooltip="Eraser"
                    data-pr-position="left"
                    disabled={!plotCoordinates}
                  />
                  <Tooltip target=".p-button" />
                </div>
              )}
              {pinCoordinates && (
                <>
                  <div className="col-6 md:col-3 p-1">
                    <Button
                      severity="secondary"
                      outlined
                      icon=" pi pi-directions text-700 text-xs"
                      className="bg-white no-outline w-xs sidebutton"
                      onClick={handleGetDirections}
                      data-pr-tooltip="Get direction"
                      data-pr-position="left"
                      disabled={!pinCoordinates}
                    />
                    <Tooltip target=".p-button" />
                  </div>
                  {isDownload && (
                    <div className="progress-spinner">
                      <div className="custom-spinner"></div>
                    </div>
                  )}
                </>
              )}
              {plotCoordinates && (
                <>
                  <div className="col-6 md:col-3 p-1">
                    <Button
                      raised
                      severity="secondary"
                      outlined
                      icon="pi pi-arrow-circle-down text-700 text-xs"
                      className="bg-white no-outline w-xs sidebutton"
                      onClick={handleDownload}
                      data-pr-tooltip="Download pdf"
                      data-pr-position="left"
                      disabled={!plotCoordinates || isDownload}
                    />
                    <Tooltip target=".p-button" />
                  </div>
                  {isDownload && (
                    <div className="progress-spinner">
                      <div className="custom-spinner"></div>
                    </div>
                  )}
                </>
              )}
              <div className="col-6 md:col-3 p-1">
                <Button
                  severity="secondary"
                  outlined
                  icon="pi pi-info-circle text-700 text-xs"
                  className="bg-white no-outline w-xs sidebutton"
                  onClick={handleToggle}
                  data-pr-tooltip="Information"
                  data-pr-position="left"
                />
                <Tooltip target=".p-button" />
              </div>

              <div className="col-6 md:col-3 p-1">
                <Button
                  severity="secondary"
                  outlined
                  icon="pi pi-map text-700 text-xs"
                  className="bg-white no-outline w-xs sidebutton"
                  onClick={handleSevenEnquiry}
                  data-pr-tooltip="7/12 or Index2"
                  data-pr-position="left"
                />
                <Tooltip target=".p-button" />
              </div>

              <div className="col-6 md:col-3 p-1">
                <Button
                  severity="secondary"
                  outlined
                  icon="pi pi-arrow-left text-700 text-xs"
                  className="bg-white no-outline w-xs sidebutton"
                  onClick={undoLastPoint}
                  data-pr-tooltip="Undo Last Edit"
                  data-pr-position="left"
                />
                <Tooltip target=".p-button " />
              </div>
            </div>
            {isDistanceVisible && (
              <div className="grid top-0 w-4 md:w-2 lg:w-1 right-0 flex-row mb-8 mr-6 absolute">
                <div className="col-12 md:col-12 ">
                  <div className="distance-container text-center">
                    <p> {totalDistance.toFixed(2)} m</p>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <MzDialog
        onHide={() => setVisibleSevenEnquiry(false)}
        visible={visibleSevenEnquiry}
        children={
          <AddEditSevenEnquiryScreen
            setvisibleSevenEnquiry={setVisibleSevenEnquiry}
          />
        }
      ></MzDialog>
      {showPreview && (
        <>

          <div className="fixed top-0 left-0 w-full h-full bg-black-alpha-50 flex align-items-center justify-content-center z-5" style={{ zIndex: 9999 }}>
            <div className="bg-white border-round shadow-5 w-80rem flex flex-column" style={{ maxWidth: '95vw', maxHeight: '100vh' }}>
              <div className="p-3 bg-blue-50 border-bottom-1 surface-border">
                <div className="text-blue-800 text-sm">
                  <p className="text-blue-800 text-sm m-1">
                    <strong>नकाशा आपल्या गरजेनुसार सेट करा</strong> — PDF मध्ये तो ह्याच रूपात दिसेल.
                  </p>
                  <p className="text-blue-800 text-sm m-1">
                    <strong>Adjust the map view as per your need</strong> — it will appear in the PDF exactly in this format.
                  </p>
                </div>
              </div>
              <div className="p-3">

                <div ref={previewMapRef} className="relative w-full h-30rem border-1 surface-border border-round overflow-hidden bg-gray-100" style={{
                  '--gm-style-cc': 'none',
                  '--gm-style-iw': 'none'
                }} />
              </div>
              <div className="flex justify-content-end gap-2 p-3 border-top-1 surface-border">
                <Button
                  label="Cancel"
                  className="p-button-sm p-button-outlined"
                  onClick={() => setShowPreview(false)}
                />
                <Button
                  label="Confirm & Download PDF"
                  className="p-button-sm"
                  icon="pi pi-download"
                  onClick={handleConfirmDownload}
                  loading={isDownload}
                />
              </div>
            </div>
          </div>
        </>
      )}

      <Toast ref={toastRef} />
    </div>
  )
}

export default GmapComponent
